"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUpload = ImageUpload;
const react_1 = __importStar(require("react"));
const ImageUpload_scss_json_1 = __importDefault(require("./ImageUpload.scss.json"));
require("./ImageUpload.scss");
const useAuth_1 = require("lincd-auth/lib/hooks/useAuth");
const react_2 = require("@tolgee/react");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const core_1 = require("@capacitor/core");
const camera_1 = require("@capacitor/camera");
const helper_1 = require("profile-plus/lib/utils/helper");
const ImageResize_1 = require("lincd-server-utils/lib/utils/ImageResize");
const helper_2 = require("profile-pics/lib/utils/helper");
const ClassNames_1 = require("lincd/lib/utils/ClassNames");
const helper_3 = require("../../utils/helper");
const package_1 = require("../../package");
const JSONParser_1 = require("lincd-jsonld/lib/utils/JSONParser");
function ImageUpload({ uploadUrl, of, subPlayer, property, limit = 3, thumbnailWidth = 100, thumbnailHeight = 100, onCallback, isLoading = false, }) {
    const auth = (0, useAuth_1.useAuth)();
    const user = auth.user;
    const { t } = (0, react_2.useTranslate)();
    const [images, setImages] = (0, react_1.useState)([]);
    const [uploading, setUploading] = (0, react_1.useState)(false); // Upload state
    const getImages = () => __awaiter(this, void 0, void 0, function* () {
        const response = yield Server_1.Server.call(package_1.packageName, 'getTopicImages', of.uri);
        setImages(response && response.length > 0 ? response : []);
    });
    (0, react_1.useEffect)(() => {
        if (of === null || of === void 0 ? void 0 : of.uri) {
            getImages();
        }
    }, [of === null || of === void 0 ? void 0 : of.uri]);
    const handleFileChange = () => __awaiter(this, void 0, void 0, function* () {
        if (images.length >= limit) {
            alert(`You can only upload up to ${limit} images.`);
            return;
        }
        try {
            const imageOptions = {
                quality: 90,
                allowEditing: false,
                width: 1024,
                resultType: core_1.Capacitor.isNativePlatform()
                    ? camera_1.CameraResultType.Uri
                    : camera_1.CameraResultType.DataUrl,
                source: core_1.Capacitor.isNativePlatform()
                    ? camera_1.CameraSource.Prompt
                    : camera_1.CameraSource.Photos,
            };
            const image = yield camera_1.Camera.getPhoto(imageOptions);
            if (image) {
                // upload the image to the server
                yield uploadImage(image);
            }
        }
        catch (err) {
            console.warn('Error capturing image:', err);
        }
    });
    const onFileTransferUpload = (file) => __awaiter(this, void 0, void 0, function* () {
        const fileTransfer = new FileTransfer();
        const token = yield auth.getAccessToken();
        // generate a unique file name for the image
        // example: originalName.jpg -> originalName_1633024800000_abcd12.jpg
        const filename = (0, helper_1.generateUniqueFileName)(file.path.substring(file.path.lastIndexOf('/') + 1));
        const options = {
            fileKey: 'file',
            fileName: filename,
            mimeType: 'image/jpeg',
            chunkedMode: false,
            headers: {
                Authorization: 'Bearer ' + token,
            },
        };
        return new Promise((resolve, reject) => {
            fileTransfer.upload(file.path, encodeURI(uploadUrl), (success) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                const response = JSON.parse(success.response);
                const parsed = yield JSONParser_1.JSONParser.parseObject(response, null, false, null, true);
                const image = (_a = parsed.content) === null || _a === void 0 ? void 0 : _a.images;
                const topicScore = (_b = parsed.content) === null || _b === void 0 ? void 0 : _b.topicScore;
                if (!image) {
                    reject(new Error('Image upload failed: No image in response'));
                    return;
                }
                // extract image from response.images
                resolve({
                    uri: image.uri,
                    contentUrl: image.contentUrl,
                });
                // send the update topicScore to the callback
                if (onCallback && topicScore) {
                    onCallback(topicScore);
                }
            }), (error) => {
                reject(new Error('Upload error: ' + JSON.stringify(error)));
            }, options);
        });
    });
    const uploadImage = (file) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        setUploading(true);
        try {
            let newImage = null;
            if (core_1.Capacitor.isNativePlatform()) {
                // use FileTransfer for native platforms
                newImage = yield onFileTransferUpload(file);
            }
            else {
                // use fetch for web platforms
                const formData = new FormData();
                const blob = yield fetch(file.dataUrl).then((res) => res.blob());
                // generate a unique filename
                const filename = `${user.identifier}_${Date.now()}.jpg`;
                formData.append('image', blob, filename);
                const response = yield fetch(uploadUrl, {
                    method: 'POST',
                    body: formData,
                });
                if (!response.ok) {
                    throw new Error('Failed to upload image');
                }
                const data = yield response.json();
                const parsed = yield JSONParser_1.JSONParser.parseObject(data, null, false, null, true);
                newImage = parsed.content.images;
                // send the update topicScore to the callback
                if (onCallback && parsed.content.topicScore) {
                    onCallback((_a = parsed.content) === null || _a === void 0 ? void 0 : _a.topicScore);
                }
            }
            if (!newImage) {
                alert(t('imageUpload.uploadError', `Hmm, things are a little crowded right now. We were not able to upload the image. Please try again in a moment.`));
                return;
            }
            // resize the image directly, so we use thumbnail image for the preview
            // const resizeImageSrc = imageSrc(newImage.contentUrl);
            setImages((prevImages) => {
                const updated = [
                    ...prevImages,
                    { uri: newImage.uri, contentUrl: newImage.contentUrl },
                ];
                return updated;
            });
        }
        catch (err) {
            console.warn('Error uploading image:', err);
            alert(t('imageUpload.uploadError', `Hmm, things are a little crowded right now. We were not able to upload the image. Please try again in a moment.`));
        }
        finally {
            setUploading(false);
        }
    });
    // delete the image from the server
    const handleDeleteImage = (imageUri) => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield (0, helper_3.withRetry)(() => Server_1.Server.call(package_1.packageName, {
                method: 'deleteTopicImage',
                overwriteData: true,
            }, of.uri, imageUri, subPlayer));
            if (response) {
                // update the images state to remove the deleted image
                const updatedImages = images.filter((image) => image.uri !== imageUri);
                setImages(updatedImages);
                if (onCallback) {
                    onCallback(response.topicScore);
                }
            }
        }
        catch (err) {
            console.warn('Error deleting image:', err);
            alert(t('imageUpload.uploadError', `Things are running a bit slow. We weren’t able to delete the image. Could you try again in a little while?`));
        }
    });
    // crop the image based on the thumbnail size
    // this also fix android development path
    const imageSrc = (source) => {
        return (0, ImageResize_1.getResizedImagePath)((0, helper_2.replaceLocalhostWithSiteRoot)(source), thumbnailWidth ? thumbnailWidth * 2 : NaN, thumbnailHeight ? thumbnailHeight * 2 : thumbnailWidth ? NaN : 100);
    };
    return (react_1.default.createElement("div", { className: ImageUpload_scss_json_1.default.root },
        images.map((image, index) => (react_1.default.createElement("div", { key: index, className: ImageUpload_scss_json_1.default.item, style: { width: thumbnailWidth, height: thumbnailHeight } },
            react_1.default.createElement("img", { src: imageSrc(image.contentUrl), alt: `Uploaded ${index + 1}` }),
            react_1.default.createElement("button", { className: ImageUpload_scss_json_1.default.delete, onClick: () => handleDeleteImage(image.uri) },
                react_1.default.createElement("svg", { width: "15", height: "15", fill: "none", viewBox: "0 0 15 15" },
                    react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11.782 4.032a.575.575 0 1 0-.813-.814L7.5 6.687 4.032 3.218a.575.575 0 0 0-.814.814L6.687 7.5l-3.469 3.468a.575.575 0 0 0 .814.814L7.5 8.313l3.469 3.469a.575.575 0 0 0 .813-.814L8.313 7.5z", clipRule: "evenodd" })))))),
        images.length < limit && (react_1.default.createElement("div", { className: (0, ClassNames_1.cl)(ImageUpload_scss_json_1.default.item, ImageUpload_scss_json_1.default.addNew), style: { width: thumbnailWidth, height: thumbnailHeight }, onClick: handleFileChange }, uploading || isLoading ? (react_1.default.createElement("span", { className: (0, ClassNames_1.cl)(ImageUpload_scss_json_1.default.spinner, ImageUpload_scss_json_1.default.absCenter) }, "...")) : (react_1.default.createElement("svg", { className: ImageUpload_scss_json_1.default.absCenter, viewBox: "0 -960 960 960", height: "48", width: "48" },
            react_1.default.createElement("path", { fill: "currentColor", d: "M450-450H200v-60h250v-250h60v250h250v60H510v250h-60v-250Z" })))))));
}
//# sourceMappingURL=ImageUpload.js.map